import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { clearError } from '../../redux/reducers/quizzes';
const NotificationToastComponent = ({ error, errorDetail, clearError, }) => {
    const [move, setMove] = useState('');
    useEffect(() => {
        if (error) {
            setMove('dropdown');
            setTimeout(() => {
                setMove('riseup');
                clearError({});
            }, 5000);
        }
    }, [error]);
    return (React.createElement("div", { className: `notification-toast__container ${move}` },
        React.createElement("div", { className: `notification-toast__content` },
            React.createElement("div", { className: "notification-toast__message" },
                errorDetail,
                React.createElement("button", { className: `notification-toast__close` }, "x")),
            React.createElement("div", { className: "notification-toast__timer" }))));
};
const mapStateToProps = (state) => {
    return {
        error: state.quizState.error,
        errorDetail: state.quizState.errorDetail,
    };
};
const mapDispatchToProps = {
    clearError,
};
export const NotificationToast = connect(mapStateToProps, mapDispatchToProps)(NotificationToastComponent);
